import axios from 'axios';
import _ from 'lodash';
import queryString from 'query-string';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import hyperid from 'hyperid';

export const EmergencyMessaging = (props) => {
  const { REACT_APP_MY_LOBBY_BACKEND_URL } = process.env;
  const history = useHistory();

  const [employees, setEmployees] = useState();
  const [totalEmployees, setTotalEmployees] = useState(0);
  const [presentEmployees, setpresentEmployees] = useState(0);
  const [absentEmployees, setAbsentEmployees] = useState(0);
  const [sortReport, setSortReport] = useState(false);
  const [sortedEmployees, setSortedEmployees] = useState([]);
  const [clicked, setClicked] = useState(false);
  const [warden, setWarden] = useState();
  const [rollCallDate, setRollCallDate] = useState();
  const [rollCallSortedDate, setRollCallSortedDate] = useState();
  const [loadError, setLoadError] = useState();
  const [notice, setNotice] = useState();
  const parsedQueryString = queryString.parse(window.location.search);
  const employeeId = parseInt(parsedQueryString.employeeId, 10);
  const sort = parsedQueryString.sort;
  const instance = hyperid();
  const submit = async (instanceId) => {
    try {
      const { id, name, email, accountId, phonesms, phonevoice, musterLocation, siteId } = warden;
      const login = await axios.post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users/login`, {
        email: `${instanceId}@my-lobby.com`,
        password: `${instanceId}@my-lobby.com`,
        siteId: siteId,
      });

      const newWarden = { wardenId: id, name, email, accountId, phonesms, phonevoice, musterLocation, siteId };
      axios
        .get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/sites/${siteId}`, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: login.data?.id,
          },
        })
        .then((res) => {
          if (res.data?.site.emergency === true) {
            const sortedRollCallData = {
              warden: newWarden,
              totalEmployees: totalEmployees,
              presentEmployees: presentEmployees,
              absentEmployees: absentEmployees,
              sortedEmployees: sortedEmployees,
            };

            localStorage.setItem('sortedData', JSON.stringify(sortedRollCallData));
            const missingPeople = sortedEmployees.filter((item) => item.present === false);
            const body = JSON.stringify({
              ...newWarden,
              totalEmployees: totalEmployees,
              presentEmployees: presentEmployees,
              absentEmployees: absentEmployees,
              missingPeople: missingPeople,
              rolcallStartedDate: rollCallDate,
              rollcallSortedDate: rollCallSortedDate,
              rollcallSendReportDate: new Date().getTime(),
            });
            axios
              .post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/emergency_reports/add`, body, {
                headers: { 'Content-Type': 'application/json' },
              })
              .then((res) => {
                history.push('/rollcallsummary');
              })
              .catch((err) => {
                console.log(err);
              });
          } else {
            setNotice('This emergency has already been ended, so this roll call can no longer be submitted. Contact your crisis team lead if you still need to report.');
          }
        })
        .catch((err) => {
          console.log(err);
          setNotice('We could not confirm the emergency status, so your roll call was not sent. Check your connection and try again.');
        });
    } catch (err) {
      console.log(err);
      setNotice('Your roll call could not be sent. Check your connection and try again, or call your crisis team lead.');
    }
  };

  useEffect(() => {
    props.hideLoader();
  }, [props]);

  useEffect(() => {
    if (employeeId && !sort) {
      axios
        .get(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/employees/${employeeId}`)
        .then((res) => {
          setWarden(res.data?.employee);
        })
        .catch((err) => {
          console.log(err);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [employeeId]);

  useEffect(() => {
    if (sort === 'true') {
      const sortedCallData = JSON.parse(localStorage.getItem('sortedData'));
      setSortReport(sort);
      setWarden(sortedCallData?.warden);
      setTotalEmployees(sortedCallData?.totalEmployees);
      setpresentEmployees(sortedCallData?.presentEmployees);
      setAbsentEmployees(sortedCallData?.absentEmployees);
      setSortedEmployees(sortedCallData?.sortedEmployees);
    }
  }, [sort]);

  useEffect(() => {
    if (warden && !sort) {
      const body = JSON.stringify({
        accountId: warden.accountId,
        musterLocation: warden.musterLocation,
        siteId: warden.sites[0],
      });
      const config = {
        method: 'post',
        url: `${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitors/getcurrentvisitors`,
        headers: {
          'Content-Type': 'application/json',
        },
        data: body,
      };

      axios(config)
        .then((res) => {
          setLoadError(undefined);
          let allEmployees = res.data?.visitorspresent?.length;
          if (allEmployees === 0) {
          } else {
            for (let i = 0; i < allEmployees; i++) {
              if (res.data?.visitorspresent[i]?.visitors?.length > 0) {
                allEmployees = allEmployees + res.data?.visitorspresent[i].visitors?.length;
              }
            }
          }
          setTotalEmployees(allEmployees);
          setEmployees(res.data?.visitorspresent);
        })
        .catch((err) => {
          console.log(err);
          setLoadError(
            err.response?.data?.error?.message ||
              'We could not load the people signed in at your site. This is a problem loading the list, not an empty site - refresh this page, and tell your crisis team lead if it keeps happening.',
          );
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [warden]);

  useEffect(() => {
    let presentCounter = 0;
    let absentCounter = 0;
    if (employees?.length > 0 && sortedEmployees?.length === 0) {
      employees.forEach((e) => {
        if (e.present !== undefined && e.present === true) {
          presentCounter++;
        } else if (e.present !== undefined && e.present === false) {
          absentCounter++;
        }

        if (e.visitors?.length > 0) {
          e.visitors.forEach((v) => {
            if (v.present !== undefined && v.present === true) {
              presentCounter++;
            } else if (v.present !== undefined && v.present === false) {
              absentCounter++;
            }
          });
        }
      });
      setpresentEmployees(presentCounter);
      setAbsentEmployees(absentCounter);
    } else if (sortedEmployees?.length > 0) {
      sortedEmployees.forEach((e) => {
        if (e.present !== undefined && e.present === true) {
          presentCounter++;
        } else if (e.present !== undefined && e.present === false) {
          absentCounter++;
        }

        if (e.visitors?.length > 0) {
          e.visitors.forEach((v) => {
            if (v.present !== undefined && v.present === true) {
              presentCounter++;
            } else if (v.present !== undefined && v.present === false) {
              absentCounter++;
            }
          });
        }
      });
      setpresentEmployees(presentCounter);
      setAbsentEmployees(absentCounter);
    }
  }, [employees, sortedEmployees]);

  useEffect(() => {
    if (!sort) {
      if (employees) {
        employees.map((e) => {
          e.edit = false;
          if (e.visitors?.length > 0) {
            e.visitors.map((m) => {
              m.edit = false;
              return e;
            });
          }
          return e;
        });
        employees.forEach((e) => {
          if (e.visitors?.length > 0) {
            e.visitors.forEach((v) => {
              employees.push(v);
            });
            delete e.visitors;
          }
        });

        employees.forEach((e) => {
          if (e.present === undefined || e.present === null) {
            e.present = false;
          }
        });

        const sortedArr = employees.sort((a, b) => Number(a.present) - Number(b.present));
        setSortedEmployees(sortedArr);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sortReport]);

  return !sortReport ? (
    <div>
      <div className="container max-w-sm mx-auto bg-white-200 pt-6">
        <div className="m-2 text-black p-2">
          <h1 className="font-bold text-2xl">
            Warden:<span>&nbsp;</span>
            <span className="font-light">{warden?.name}</span>
          </h1>

          <h1 className="font-bold font-bold text-2xl">
            Muster Location: <span className="font-light text-base">{warden?.musterLocation}</span>
          </h1>
          <h1 className="font-extrabold text-center text-3xl">Roll Call</h1>
        </div>

        <div className="text-black flex justify-center pb-2">
          <span className="font-bold mx-1">
            Total:<span style={{ color: '#007DA5' }}>{totalEmployees}</span>
          </span>
          <span>|</span>
          <span className="font-bold mx-1">
            Present: <span style={{ color: '#0C5800' }}>{presentEmployees}</span>
          </span>
          <span>|</span>
          <span className="font-bold mx-1">
            Absent: <span style={{ color: '#FF0000' }}>{absentEmployees}</span>
          </span>
        </div>

        <div className="p-4 grid grid-cols-12">
          <div className="pl-8 text-center text-black font-bold col-start-2 col-span-2">Name</div>
          <div className="text-center text-black col-start-5 col-span-4">
            <span>
              Filter: A<span>&gt;</span>Z{' '}
              <img
                className="inline cursor-pointer"
                src="Polygon3.png"
                alt="filterbutton"
                onClick={() => {
                  if (clicked === false) {
                    const sortedArray = _.sortBy(employees, ['name']);
                    setEmployees(sortedArray);
                    setClicked(true);
                  } else {
                    const unsortedArray = _.reverse(employees, ['name']);
                    setEmployees(unsortedArray);
                    setClicked(false);
                  }
                }}
              />
            </span>
          </div>
          <div className="pr-10 text-center text-black font-bold col-start-9 col-span-3">Status</div>
        </div>

        <div className="grid grid-cols-12 gap-2">
          <div className="col-start-7 col-end-9">
            <img className="pl-8" src="./statusOk.png" alt="present" />
          </div>
          <div className="col-start-10 col-end-12">
            <img className="pl-6" src="./statusNotOk.png" alt="notPresent" />
          </div>
        </div>
        <div style={{ height: 300, overflow: 'scroll', marginBottom: 20, marginTop: 5 }}>
          {loadError ? (
            <div className="text-center my-10 px-4" style={{ color: '#B00020' }}>
              {loadError}
            </div>
          ) : employees !== undefined && employees.length === 0 ? (
            <div className="text-black text-center my-10"> Individuals within your rollcall did not sign in today</div>
          ) : (
            employees?.map((item) => {
              return (
                <div key={item.id}>
                  <div className="grid grid-cols-12 gap-2 p-2">
                    <div className="text-black col-start-1 col-span-5" style={{ fontSize: 18 }}>
                      {item.name}
                      {item.visitors?.length > 0 ? (
                        <span
                          className="mx-2"
                          style={{
                            color: '#FF0000',
                            fontSize: 22,
                          }}
                        >
                          V
                        </span>
                      ) : null}
                    </div>

                    <div className="col-start-7 col-end-9">
                      <button
                        onClick={() => {
                          if (!rollCallDate) {
                            setRollCallDate(new Date().getTime());
                          }
                          const employeeChange = employees.map((e) => {
                            const newE = { ...e };
                            if (e.id === item.id) {
                              newE.present = true;
                            }
                            return newE;
                          });
                          setEmployees(employeeChange);
                        }}
                        className="text-black font-bold shadow-md"
                        style={{
                          borderRadius: '20px 0px 0px 20px',
                          backgroundColor: item.present !== undefined && item.present === true ? '#00C82C' : '#D9D9D9',
                          width: 76,
                          height: 30,
                        }}
                      >
                        Yes
                      </button>
                    </div>
                    <div className="col-start-10 col-end-12">
                      <button
                        onClick={() => {
                          if (!rollCallDate) {
                            setRollCallDate(new Date().getTime());
                          }
                          const employeeChange = employees.map((e) => {
                            const newE = { ...e };
                            if (e.id === item.id) {
                              newE.present = false;
                            }
                            return newE;
                          });
                          setEmployees(employeeChange);
                        }}
                        className="text-black font-bold shadow-md"
                        style={{
                          borderRadius: '0px 20px 20px 0px',
                          backgroundColor: item.present !== undefined && item.present === false ? '#FF9D9D' : '#D9D9D9',
                          width: 76,
                          height: 30,
                        }}
                      >
                        No
                      </button>
                    </div>
                  </div>
                  {item.visitors?.length > 0
                    ? item.visitors.map((visitor) => {
                        return (
                          <div key={visitor.id} className="mx-2 grid grid-cols-12 gap-2">
                            <div className="ml-2 my-2 text-black col-start-1 col-span-5" style={{ color: '#FF0000', fontSize: 18 }}>
                              {visitor.name}
                            </div>
                            <div className="my-2 col-start-7 col-end-9">
                              <button
                                onClick={() => {
                                  if (!rollCallDate) {
                                    setRollCallDate(new Date().getTime());
                                  }
                                  const visitorChange = item.visitors.map((v) => {
                                    const newV = { ...v };
                                    if (v.id === visitor.id) {
                                      newV.present = true;
                                    }
                                    return newV;
                                  });
                                  const employeeChange = employees.map((e) => {
                                    const newEmp = { ...e };
                                    if (e.id === item.id) {
                                      newEmp.visitors = visitorChange;
                                    }
                                    return newEmp;
                                  });
                                  setEmployees(employeeChange);
                                }}
                                className="text-black font-bold shadow-md"
                                style={{
                                  borderRadius: '20px 0px 0px 20px',
                                  backgroundColor: visitor.present !== undefined && visitor.present === true ? '#00C82C' : '#D9D9D9',
                                  width: 76,
                                  height: 30,
                                }}
                              >
                                Yes
                              </button>
                            </div>
                            <div className="my-2 col-start-10 col-end-12">
                              <button
                                onClick={() => {
                                  if (!rollCallDate) {
                                    setRollCallDate(new Date().getTime());
                                  }
                                  const visitorChange = item.visitors.map((v) => {
                                    const newV = { ...v };
                                    if (v.id === visitor.id) {
                                      newV.present = false;
                                    }
                                    return newV;
                                  });
                                  const employeeChange = employees.map((e) => {
                                    const newEmp = { ...e };
                                    if (e.id === item.id) {
                                      newEmp.visitors = visitorChange;
                                    }
                                    return newEmp;
                                  });
                                  setEmployees(employeeChange);
                                }}
                                className="text-black font-bold shadow-md"
                                style={{
                                  borderRadius: '0px 20px 20px 0px',
                                  backgroundColor: visitor.present !== undefined && visitor.present === false ? '#FF9D9D' : '#D9D9D9',
                                  width: 76,
                                  height: 30,
                                }}
                              >
                                No
                              </button>
                            </div>
                          </div>
                        );
                      })
                    : null}
                </div>
              );
            })
          )}
        </div>
        {notice ? (
          <div className="text-center pb-2 px-4" style={{ color: '#B00020' }}>
            {notice}
          </div>
        ) : null}
        <div className="flex flex-row justify-center pb-20">
          <button
            onClick={() => {
              setRollCallSortedDate(new Date().getTime());
              setSortReport(true);
            }}
            className="bg-blue-500 hover:bg-blue-700 text-white text-2xl font-bold border-black-900 py-2 px-4 rounded-full"
            style={{ width: '70%', border: '2px solid #000000' }}
            disabled={employees !== undefined && employees.length === 0 ? true : false}
          >
            Sort Report Prior to Sending
          </button>
        </div>
      </div>
      <div
        className="text-2xl text-center text-white"
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          background: '#272223',
          height: 43,
        }}
      >
        <footer>
          <p>Powered by My-Lobby.com</p>
        </footer>
      </div>
    </div>
  ) : (
    <>
      <div className="container max-w-sm mx-auto bg-white-200 pt-6">
        <div className="text-black p-2">
          <h1 className="font-bold text-2xl">
            Warden:<span>&nbsp;</span>
            <span className="font-light">{warden?.name}</span>
          </h1>

          <h1 className="font-bold font-bold text-2xl">
            Muster Location: <span className="font-light text-base">{warden?.musterLocation}</span>
          </h1>
          <h1 className="font-extrabold text-center text-3xl">Sorted Roll Call</h1>
        </div>

        <div className="text-black flex justify-center pb-2">
          <span className="font-bold mx-1">
            Total:<span style={{ color: '#007DA5' }}>{totalEmployees}</span>
          </span>
          <span>|</span>
          <span className="font-bold mx-1">
            Present: <span style={{ color: '#0C5800' }}>{presentEmployees}</span>
          </span>
          <span>|</span>
          <span className="font-bold mx-1">
            Absent: <span style={{ color: '#FF0000' }}>{absentEmployees}</span>
          </span>
        </div>

        <div className="grid grid-cols-12 gap-2 p-2">
          <div className="text-black font-bold col-start-1 col-span-5">Name</div>

          <div className="pr-10 text-black font-bold col-start-9 col-span-3">Status</div>
        </div>

        <div style={{ height: 300, overflow: 'scroll', marginBottom: 20, marginTop: 5 }}>
          {sortedEmployees?.map((item) => {
            return (
              <div key={item.id}>
                <div className="grid grid-cols-12 gap-2 p-2">
                  <div className="text-black col-start-1 col-span-5" style={{ fontSize: 18 }}>
                    {item.name}
                  </div>

                  {item.edit === false ? (
                    <>
                      <div className="col-start-10">
                        <button className="text-black font-bold">
                          {item.present ? <img src="./Ellipseg.png" alt="Edit employee" /> : <img src="./Ellipse.png" alt="Edit employee" />}
                        </button>
                      </div>

                      <div className="col-start-11">
                        <button
                          onClick={() => {
                            const employeeChange = sortedEmployees.map((e) => {
                              const newE = { ...e };
                              if (e.id === item.id) {
                                newE.edit = true;
                              }
                              return newE;
                            });
                            setSortedEmployees(employeeChange);
                          }}
                          className="text-black font-bold"
                          style={{
                            borderRadius: '0px 20px 20px 0px',
                            width: '15px',
                            height: '15px',
                            top: '292px',
                            left: '353px',
                          }}
                        >
                          <img src="./Vector.png" alt="Edit employee"></img>
                        </button>
                      </div>
                    </>
                  ) : null}
                  {item.edit ? (
                    <div className="grid col-start-6 col-end-12">
                      <div className="col-start-6">
                        <button
                          onClick={() => {
                            const employeeChange = sortedEmployees.map((e) => {
                              const newE = { ...e };
                              if (e.id === item.id) {
                                newE.edit = false;
                                newE.present = true;
                              }
                              return newE;
                            });
                            const sortedArr = employeeChange.sort((a, b) => Number(a.present) - Number(b.present));
                            setSortedEmployees(sortedArr);
                          }}
                          className="text-black font-bold shadow-md"
                          style={{
                            borderRadius: '20px 0px 0px 20px',
                            backgroundColor: '#00C82C',
                            width: 76,
                            height: 30,
                          }}
                        >
                          Yes
                        </button>
                      </div>
                      <div className="col-start-9">
                        <button
                          onClick={() => {
                            const employeeChange = sortedEmployees.map((e) => {
                              const newE = { ...e };
                              if (e.id === item.id) {
                                newE.edit = false;
                                newE.present = false;
                              }
                              return newE;
                            });
                            const sortedArr = employeeChange.sort((a, b) => Number(a.present) - Number(b.present));
                            setSortedEmployees(sortedArr);
                          }}
                          className="text-black font-bold shadow-md"
                          style={{
                            borderRadius: '0px 20px 20px 0px',
                            backgroundColor: '#D9D9D9',
                            width: 76,
                            height: 30,
                          }}
                        >
                          No
                        </button>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>
            );
          })}
        </div>
        <div className="flex flex-row justify-center mt-2">
          <button
            onClick={async () => {
              console.log('warden print...............=>', warden);
              const { siteId } = warden;

              const instanceId = instance.uuid;
              axios
                .post(`${REACT_APP_MY_LOBBY_BACKEND_URL}/api/visitor_users`, {
                  email: `${instanceId}@my-lobby.com`,
                  password: `${instanceId}@my-lobby.com`,
                  siteId: siteId,
                })
                .then((res) => {
                  submit(instanceId);
                })
                .catch((error) => {
                  submit(instanceId);
                  console.log(error);
                });
            }}
            className="bg-blue-500 hover:bg-blue-700 text-white text-2xl font-bold border-black-900 py-2 px-4 rounded-full"
            style={{
              width: 350,
              border: '2px solid #000000',
            }}
          >
            Send Report
          </button>
        </div>
      </div>
      <div
        className="text-2xl text-center text-white"
        style={{
          position: 'fixed',
          bottom: 0,
          width: '100%',
          background: '#272223',
          height: 43,
        }}
      >
        <footer>
          <p>Powered by My-Lobby.com</p>
        </footer>
      </div>
    </>
  );
};
